export default "__VITE_ASSET__5mfll4ea__"